/**
 * TODO(delivery-api): replace this fallback with the tenant/workspace delivery
 * capability returned by the API, then pass that value to DeliverStoryFlow.
 */
export const DEFAULT_MAX_ALERT_CONDITIONS = 2;
